








import AceEditor from './editor/ace.vue';
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';
import { JsonStringify, JsonParse } from './utils/JsonTransform';
import editorFocusMixin from './mixins/editorFocus';
export default Vue.extend({
    mixins: [editorFocusMixin()],
    data() {
        return {
            initData: '',
            originEditorRef: {}
        }
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection,
            dataSource: (state: any) => state.screen.editor.dataSource,
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup;
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 && this.isReleasePart ? this.selectGroup[0] : {}
        },
        /**
         * 优化选中part的性能
         * 修改为释放part，才更新配置项 -- 样式 or 数据
         */
        isReleasePart(): boolean {
            return this.partSelection.releasePart;
        },
        partData(): any {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        /**
         * 用户编辑完静态数据之后，保留下来的值
         */
        sourceData() {
            return this.partData && this.partData.staticData && this.partData.staticData.sourceData || '';
        },
        drawerStatus(): boolean {
            return this.dataSource &&  this.dataSource.drawerStatus || false;
        }
    },
    watch: {
        curSelectPart() {
            this.updateStaticData();
        },
        /**
         * 监听抽屉的开关
         */
        drawerStatus(): void {
            this.$nextTick( () => {
                if(!this.drawerStatus) {
                    return;
                }
                (this.originEditorRef as any).alignCursors();
            });
        }
    },
    methods: {
        ...mapMutations([
            'set_partData',
        ]),
        updateStaticData() {
            if (!this.isReleasePart) {
                this.initData = '';
                return
            }
            if (!_.isEmpty(this.curSelectPart)) {
                // 如果静态数据模块没有保存上次编辑的数据，就调用获取静态数据
                const hasCacheSourceData = this.sourceData;
                this.initData = hasCacheSourceData ?
                    hasCacheSourceData:
                    JsonStringify((this.curSelectPart as any).getPartStaticData());
                // 第一次加载设置展示数据
                // this.editorBlur(this.initData);
            }
        },
        editorBlur(staticData: any) {
            // console.log("editorBlur");
            
            if (_.isEmpty(this.curSelectPart)) {
                return;
            }
            // 需要先判断staticData是否存在
            this.partData.staticData.sourceData = staticData;

            this.onEmitScriptChange();
        },
        /**
         * 初始化编辑器的引用
         * @editor 编辑器实例的引用
         */
        onMountedEditor(editor: any) {
            this.originEditorRef = editor;
        },
        /**
         * 发射脚本编辑改变的事件
         */
        onEmitScriptChange() {
            (this.$root as any).busRef.$emit('fetchStatic');
        },
    },
    components: {
        AceEditor,
    },
    mounted() {
        this.updateStaticData();
        // console.log("static mounted");
        
    }
})
